import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorBookingItemSettingWorkflow } from '../editor-booking-item-setting/editor-booking-item-setting-workflow.model';


@Component({
    selector: 'eas-editor-booking-item-setting-value-workflow',
    templateUrl: './editor-booking-item-setting-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingValueWorkflowComponent implements OnChanges, OnInit, OnDestroy {
  @Input() itemSetting: EditorBookingItemSettingWorkflow;

  private destroyed$ = new Subject<void>();

  workflowNames: { id: string, name: string }[];

  value: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.workflowNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(workflowNames => {
        this.workflowNames = workflowNames;
        this.value = this.getValue();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.workflowNames === undefined) {
      return $localize `Not available`;
    }

    return this.itemSetting.getIdAsString(this.workflowNames);
  }
}
